import Table from "rc-table";
import OverlayLoader from "../../components/overlayLoader";
import React, { useEffect, useState } from "react";
import { getTotalOffering } from "src/firebase/admin.js";
import { useTranslation } from "react-i18next";
import Button from "../../components/button";
import CreateOffering from "../../components/createOffering/CreateOffering";
import Modal from "../../components/ui/modal";
import { deleteDoc, doc } from "firebase/firestore";
import { handleToastMessage } from "src/js/handleToastMessage";
import { db } from "src/firebase/firebase";

const ViewCardOffering = ({ offering }: any) => {
  const [cardList, setCardList] = useState([]);
  const [cardOffering, setCardOffering] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const { t } = useTranslation(["home"]);

  console.log("offering", offering);

  useEffect(() => {
    getOffering();
  }, []);

  const getOffering = async () => {
    setIsLoading(true);
    const result = await getTotalOffering(offering.id);
    setIsLoading(false);

    setCardList(result);
  };

  const handleDeleteOffering = async (id: string) => {
    setDeleteLoading(true);
    const docRef = doc(db, "Offerings", id);
    deleteDoc(docRef).then((res) => {
      handleToastMessage("success", "Delete offering successfully");
      getOffering();
      setDeleteLoading(false);
    });
  };

  const columns = [
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Offering Name")}</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 100,
      render: (cardNo: string) => <div>{cardNo}</div>,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Denomination")}</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 100,
      render: (cardNo: string, row) => (
        <div>
          {row.denominationMin} - {row.denominationMax}
        </div>
      ),
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Rate")}</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 100,
      render: (cardNo: string, row) => <div>{row.rate}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Price Group Name")}</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 100,
      render: (cardNo: string, row) => {
        return <div>{row.priceGroup.name}</div>;
      },
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Action")}</span>
        </div>
      ),
      dataIndex: "id",
      key: "id",
      width: 100,
      render: (id: string, row: any) => (
        <div className="flex gap-x-2">
          <Button size="small" onClick={() => setCardOffering(row)}>
            {t("Edit Offering")}
          </Button>
          <Button
            size="small"
            onClick={() => handleDeleteOffering(id)}
            loading={deleteLoading}
          >
            {t("Delete Offering")}
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="min-h-[400px] p-3 mt-5">
      <h1 className="mb-3 font-bold">{t("Card Offering")}</h1>
      {isLoading && <OverlayLoader />}
      <Table
        tableLayout="fixed"
        columns={columns as any}
        emptyText={t("No data found")}
        data={cardList}
        rowKey="id"
        scroll={{ x: 400 }}
        sticky={true}
        className="matrix"
        onHeaderRow={() => ({
          className: "header-title",
        })}
      />

      <Modal
        open={cardOffering ? true : false}
        onClose={() => setCardOffering(null)}
        modalClass="w-[460px]"
      >
        <CreateOffering
          cardOffering={cardOffering}
          priceGroup={offering}
          setShowRate={(value: any) => {
            setCardOffering(null);
            getOffering();
          }}
        />
      </Modal>
    </div>
  );
};

export default ViewCardOffering;
